import ProductSubCategory from "./ProductSubCategory";
export default ProductSubCategory;